import { useQuery } from 'react-query';

import { getPasswordPattern as queryFn } from 'api/endPoints/getPasswordPattern';

export const useQueryPasswordPatternWithToken = (params: { email?: string; token?: string }) => {
    return useQuery<{ message: string; pattern: string }, QueryError>(
        ['passwordPatternData ', params],
        () => queryFn(params),
        {
            enabled: Boolean(params.email) && Boolean(params.token),
        },
    );
};
